import { render, staticRenderFns } from "./AboutUsMain.vue?vue&type=template&id=134efe15&scoped=true"
import script from "./AboutUsMain.vue?vue&type=script&lang=js"
export * from "./AboutUsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134efe15",
  null
  
)

export default component.exports